export const authentication = {
  confirmEmail: {
    anActivationEmailHasBeenSent: 'U dërgua një lidhje aktivizimi, ju lutem verifikoni emailin tuaj',
    weHaveSentActivationLinkToEmailAddress: `Ju kemi dërguar një lidhje aktivizimi në adresën e emailit`,
    toVerifyYourAccount: `për të 'Verifikuar llogarinë tuaj'.`,
    onceVerifiedAutomaticallyRedirected: 'Pas verifikimit, do të ridrejtoheni automatikisht në panel.',
    didNotReceiveAnEmail: `Nuk keni marrë një email? Kontrolloni dosjen tuaj të spamit`,
    resendIn: 'Ridërgo në ',
    seconds: ' sekonda',
    resend: 'Ridërgo',
    backToSignUp: 'Kthehu te Regjistrohu',
    greatPleaseCheckYourMessage: 'Shkëlqim, ju lutem kontrolloni emailin tuaj',
    weHaveSentEmailTo: `Ju kemi dërguar një email tek`,
    withALinkToReset: ` me një lidhje për rivendosjen e llogarisë suaj. Sapo aktivizohet, do të jeni në gjendje të përfundoni krijimin e llogarisë suaj dhe të filloni versionin tuaj të lirë.`,
    resent: 'Ridërguar',
    backToLogin: 'Kthehu te Kyçja'
  },
  forgotPassword: {
    forgotPassword: 'Haruat Fjalëkalimin?',
    noWorries: 'Mos u shqetësoni,',
    weWillSendYouResetPasswordInstructions: `do t'ju dërgojmë udhëzimet për rivendosjen e fjalëkalimit`,
    workEmail: 'Email-i i Punës',
    continue: 'Vazhdo',
    backToLogin: 'Kthehu te Kyçja',
    placeholders: {
      enterYourEmail: 'Vendosni Email-in Tuaj',
    }
  },
  logout: {
    logout: 'Çkyçja',
    wantToLogOut: 'A jeni i sigurt që dëshironi të dilni?',
    yesIWillBeBack: `Po, do kthehem`,
    cancel: 'Anulo',
  },
  newPassword: {
    createNewPassword: 'Krijo një Fjalëkalim të Ri',
    yourNewPasswordMustBeDifferent: 'Fjalëkalimi juaj i ri duhet të jetë ndryshe nga ato të përdorura më parë.',
    password: 'Fjalëkalim',
    confirmPassword: 'Konfirmo Fjalëkalimin',
    setPassword: 'Vendos Fjalëkalimin',
    signUp: 'Regjistrohu',
    login: 'Kyçu',
    backTo: 'Kthehu te ',
    setAPassword: 'Vendos një Fjalëkalim',
    setNewPasswordToYourAccount: 'Vendos një fjalëkalim të ri për llogarinë tuaj për qëllime sigurie dhe privatësie',
    backToSignUp: 'Kthehu te Regjistrohu',
    placeholders: {
      enterYourPassword: 'Vendos Fjalëkalimin Tuaj',
    }
  },
  resetPassword: {
    passwordReset: 'Rivendosja e Fjalëkalimit',
    yourPasswordHasBeenSuccessfullyReset: 'Fjalëkalimi juaj është rivendosur me sukses.',
    clickBelowToLogIn: 'Klikoni më poshtë për të hyrë',
    continueToLogin: 'Vazhdoni të Kyçeni',
  },
  newSignUp: {
    welcomeBack: 'Mirë se vjen ',
    to: 'tek',
    logIn: 'Kyçu ',
    as: 'si ',
    withFacebook: 'me Facebook',
    logInWithGoogle: 'Kyçu me Google',
    or: 'OSE',
    pleaseFillAValidWorkEmail: 'Ju lutemi plotësoni një email të vlefshëm të punës*',
    workEmailIsRequired: 'Email-i i punës është i detyrueshëm*',
    pleaseFillAValidPassword: 'Ju lutemi plotësoni një fjalëkalim të vlefshëm*',
    passwordIsRequired: 'Fjalëkalimi është i detyrueshëm*',
    rememberMe: 'Më kujto',
    forgotPassword: 'Haruat Fjalëkalimin?',
    login: 'Kyçu',
    doNotHaveAnAccount: `Nuk keni një llogari?`,
    setUpAFreeAccount: 'Krijo një llogari FALAS',
    noCreditCardRequired: 'Nuk kërkohet kartë krediti',
    cancelAnytime: 'Anulo në çdo kohë',
    signUp: 'Regjistrohu ',
    signUpWithGoogle: 'Regjistrohu me Google',
    emailIsAlreadyRegistered: 'Email-i është tashmë i regjistruar tek ne, Ju lutemi klikoni te Kyçu për të vazhduar',
    phoneNumberShouldHaveMinimum7Digits: 'Numri i telefonit duhet të ketë të paktën 7 shifra*',
    phoneNumberIsRequired: 'Numri i telefonit është i detyrueshëm*',
    passwordMustContain: 'Fjalëkalimi duhet të përmbajë',
    atleast6Characters: 'të paktën 6 karaktere, ',
    oneUpperCaseLetter: '1 shkronjë të madhe ',
    oneSpecialCharacter: '1 karakter special*',
    alreadyHaveAccount: 'Tashmë keni një llogari?',
    signingUpToBotPenguinIsAConsentToOur: 'Regjistrimi për llogarinë BotPenguin është pajtimi juaj me ',
    privacyPolicy: 'Politikën e Privatësisë',
    termsAndConditions: 'Kushtet dhe Kushtet',
    and: ' dhe ',
    english: 'Anglisht',
    hindi: 'Hindi',
    german: 'Gjermanisht',
    french: 'Frëngjisht',
    portuguese: 'Portugalisht',
    spanish: 'Spanjisht',
    italian: 'Italianisht',
    russian: 'Rusisht',
    placeholders: {
      workEmail: 'Email-i i Punës*',
      password: 'Fjalëkalim*',
      phone: 'Telefoni*',
    }
  },
  unsubscribe: {
    successfullyUnsubscribed: 'Anuluar me Sukses',
    yourEmail: 'Email-i juaj ',
    haveBeenSuccessfullyUnsubscribedFrom: ' është anuluar me sukses nga',
    backToLogin: 'Kthehu te Kyçja'
  }
};
